<div class="relative">
  <div class="fixed top-0 w-full z-50">
    <div class="h-4 bg-linear"></div>
    <nav
      class="relative px-8 lg:px-12 py-4 flex justify-between items-center bg-white shadow-md"
    >
      <a class="text-3xl font-bold leading-none" href="acceuil">
        <img
          src="assets/svg/cfa-sante.svg"
          alt="h-16 md:h-32"
          alt="Cfa santé"
        />
      </a>
      <div class="xl:hidden">
        <button
          (click)="toggleMenu()"
          class="navbar-burger flex items-center border rounded-md border-yellow p-2 xl:hidden"
        >
          <img src="assets/svg/sort.svg" alt="h-16 md:h-32" alt="Menu" />
        </button>
      </div>
      <ul
        class="hidden absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 lg:mx-auto xl:flex lg:items-center lg:w-auto lg:space-x-12"
      >
        <li class="flex flex-col">
          <div
            (click)="toggleTrainingsType()"
            class="cursor-pointer text-sm w-full"
            [ngClass]="
              active_link.includes('/formations')
                ? 'font-bold border-b-2 border-yellow'
                : 'font-semibold'
            "
          >
            Formations
          </div>
          <div
            class="training-menu bg-white border-[#4b5563] shadow-2xl hidden absolute mt-8 p-4 items-start gap-4 border rounded-2xl"
          >
            <li
              (click)="toggleApprenticeship()"
              [ngClass]="
                active_link ===
                  '/formations/formations-en-apprentissage/medico-technique' ||
                active_link ===
                  '/formations/formations-en-apprentissage/social-medico-social' ||
                active_link ===
                  '/formations/formations-en-apprentissage/sante-publique'
                  ? 'font-bold border-b-2 border-yellow'
                  : 'font-semibold'
              "
              class="text-xs text-black hover:text-gray-500 mb-2 cursor-pointer"
            >
              Formations en apprentissage
            </li>
            <div *ngIf="isApprenticeshipOpen" class="ml-4 my-2">
              <li class="mb-2 list-inside list-disc">
                <a
                  [ngClass]="
                    active_link ===
                    '/formations/formations-en-apprentissage/medico-technique'
                      ? 'font-bold border-b-2 border-yellow'
                      : 'font-semibold'
                  "
                  class="text-xs text-black hover:text-gray-500"
                  href="/formations/formations-en-apprentissage/medico-technique"
                  >Sanitaire et Médico-Technique</a
                >
              </li>
              <li class="mb-2 list-inside list-disc">
                <a
                  [ngClass]="
                    active_link ===
                    '/formations/formations-en-apprentissage/social-medico-social'
                      ? 'font-bold border-b-2 border-yellow'
                      : 'font-semibold'
                  "
                  class="text-xs text-black hover:text-gray-500"
                  href="/formations/formations-en-apprentissage/social-medico-social"
                  >Social et Médico-social</a
                >
              </li>
              <li class="mb-2 list-inside list-disc">
                <a
                  [ngClass]="
                    active_link ===
                    '/formations/formations-en-apprentissage/sante-publique'
                      ? 'font-bold border-b-2 border-yellow'
                      : 'font-semibold'
                  "
                  class="text-xs text-black hover:text-gray-500"
                  href="/formations/formations-en-apprentissage/sante-publique"
                  >Santé publique</a
                >
              </li>
            </div>
            <li class="mt-4">
              <div
                [ngClass]="
                  active_link === '/formations/formation-continue'
                    ? 'font-bold border-b-2 border-yellow'
                    : 'font-semibold'
                "
                class="text-xs text-black hover:text-gray-500 cursor-pointer"
                (click)="onClick()"
                >Formation continue</div
              >
            </li>
          </div>
        </li>
        <li (click)="toggleClassMenu('/apprenti')">
          <a
            [ngClass]="
              active_link === '/apprenti'
                ? 'font-bold border-b-2 border-yellow'
                : 'font-semibold'
            "
            class="text-sm text-black hover:text-gray-500"
            href="/apprenti"
            >Apprentis</a
          >
        </li>
        <li (click)="toggleClassMenu('/employeur')">
          <a
            [ngClass]="
              active_link === '/employeur'
                ? 'font-bold border-b-2 border-yellow'
                : 'font-semibold'
            "
            class="text-sm text-black hover:text-gray-500"
            href="/employeur"
            >Employeurs</a
          >
        </li>
        <li (click)="toggleClassMenu('/ufa')">
          <a
            [ngClass]="
              active_link === '/ufa'
                ? 'font-bold border-b-2 border-yellow'
                : 'font-semibold'
            "
            class="text-sm text-black hover:text-gray-500"
            href="/ufa"
            >UFA</a
          >
        </li>
        <li (click)="toggleClassMenu('/partenaires')">
          <a
            [ngClass]="
              active_link === '/partenaires'
                ? 'font-bold border-b-2 border-yellow'
                : 'font-semibold'
            "
            class="text-sm text-black hover:text-gray-500"
            href="/partenaires"
            >Partenaires</a
          >
        </li>
        <li (click)="toggleClassMenu('/actualites')">
          <a
            [ngClass]="
              active_link === '/actualites'
                ? 'font-bold border-b-2 border-yellow'
                : 'font-semibold'
            "
            class="text-sm text-black hover:text-gray-500"
            href="/actualites"
            >Actualités</a
          >
        </li>
        <li (click)="toggleClassMenu('/contact')">
          <a
            [ngClass]="
              active_link === '/contact'
                ? 'font-bold border-b-2 border-yellow'
                : 'font-semibold'
            "
            class="text-sm text-black hover:text-gray-500"
            href="/contact"
            >Contact</a
          >
        </li>
      </ul>
      <div class="xl:flex items-center justify-center gap-2 hidden">
        <a
          [href]="settings.facebook_url || 'https://m.facebook.com/CFA-Sant%C3%A9-Martinique-110004447996015/'"
          target="_blank"
          class="p-4 border rounded-xl border-yellow"
        >
          <img
            src="assets/svg/footer-facebook.svg"
            class="w-3 xl:w-4 mx-auto hover:animate-pulse"
          />
        </a>
        <a
          [href]="settings.instagram_url || 'https://www.instagram.com/cfasante_mq/'"
          target="_blank"
          class="p-4 border rounded-xl border-yellow"
        >
          <img
            src="assets/svg/footer-instagram.svg"
            class="w-3 xl:w-4 mx-auto hover:animate-pulse"
          />
        </a>
        <a
          [href]="settings.linkedin_url || 'https://www.linkedin.com/company/cfa-sant%C3%A9-martinique'"
          target="_blank"
          class="p-4 border rounded-xl border-yellow"
        >
          <img
            src="assets/svg/footer-linkedin.svg"
            class="w-3 xl:w-4 mx-auto hover:animate-pulse"
          />
        </a>
      </div>
    </nav>
  </div>
  <div
    class="navbar-menu fixed top-4 left-0 bottom-0 w-5/6 max-w-sm py-6 px-6 bg-white border-r overflow-y-auto z-50 transition-transform transform -translate-x-full duration-500 ease-in-out"
  >
    <nav
      class="fixed top-4 left-0 bottom-0 flex flex-col w-5/6 max-w-sm py-6 px-6 bg-white overflow-y-auto"
    >
      <div class="flex items-center mb-8">
        <a class="mr-auto text-3xl font-bold leading-none" href="#">
          <img
            src="assets/svg/cfa-sante.svg"
            alt="h-16 md:h-32"
            alt="Cfa santé"
          />
        </a>
        <button (click)="toggleMenu()" class="navbar-close">
          <svg
            class="h-6 w-6 text-gray-400 cursor-pointer hover:text-gray-500"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        </button>
      </div>
      <div>
        <ul class="flex flex-col justify-between gap-8 pt-4">
          <li class="flex flex-col">
            <div
              (click)="toggleTrainingsTypeMobile()"
              class="cursor-pointer text-sm w-full"
              [ngClass]="
                active_link.includes('/formations')
                  ? 'font-bold border-b-2 border-yellow'
                  : 'font-semibold'
              "
            >
              Formations
            </div>
            <div
              class="training-menu-mobile hidden ml-4 mt-4 items-start gap-4"
            >
              <li
                (click)="toggleApprenticeship()"
                [ngClass]="
                  active_link ===
                    '/formations/formations-en-apprentissage/medico-technique' ||
                  active_link ===
                    '/formations/formations-en-apprentissage/social-medico-social' ||
                  active_link ===
                    '/formations/formations-en-apprentissage/sante-publique'
                    ? 'font-bold border-b-2 border-yellow'
                    : 'font-semibold'
                "
                class="text-xs text-black hover:text-gray-500 mb-2 cursor-pointer"
              >
                Formations en apprentissage
              </li>
              <div *ngIf="isApprenticeshipOpen" class="ml-4 my-2">
                <li class="mb-2 list-inside list-disc">
                  <a
                    [ngClass]="
                      active_link ===
                      '/formations/formations-en-apprentissage/medico-technique'
                        ? 'font-bold border-b-2 border-yellow'
                        : 'font-semibold'
                    "
                    class="text-xs text-black hover:text-gray-500"
                    href="/formations/formations-en-apprentissage/medico-technique"
                    >Sanitaire et Médico-Technique</a
                  >
                </li>
                <li class="mb-2 list-inside list-disc">
                  <a
                    [ngClass]="
                      active_link ===
                      '/formations/formations-en-apprentissage/social-medico-social'
                        ? 'font-bold border-b-2 border-yellow'
                        : 'font-semibold'
                    "
                    class="text-xs text-black hover:text-gray-500"
                    href="/formations/formations-en-apprentissage/social-medico-social"
                    >Social et Médico-social</a
                  >
                </li>
                <li class="mb-2 list-inside list-disc">
                  <a
                    [ngClass]="
                      active_link ===
                      '/formations/formations-en-apprentissage/sante-publique'
                        ? 'font-bold border-b-2 border-yellow'
                        : 'font-semibold'
                    "
                    class="text-xs text-black hover:text-gray-500"
                    href="/formations/formations-en-apprentissage/sante-publique"
                    >Santé publique</a
                  >
                </li>
              </div>
              <li class="mt-4">
                <div
                  [ngClass]="
                    active_link === '/formations/formation-continue'
                      ? 'font-bold border-b-2 border-yellow'
                      : 'font-semibold'
                  "
                  class="text-xs text-black hover:text-gray-500 cursor-pointer"
                  (click)="onClick()"
                  >Formation continue</div
                >
              </li>
            </div>
          </li>
          <li (click)="toggleClassMenu('/apprenti'); toggleMenu()">
            <a
              [ngClass]="
                active_link === '/apprenti'
                  ? 'font-bold border-b-2 border-yellow'
                  : 'font-semibold'
              "
              class="text-sm text-black hover:text-gray-500"
              href="/apprenti"
              >Apprentis</a
            >
          </li>
          <li (click)="toggleClassMenu('/employeur'); toggleMenu()">
            <a
              [ngClass]="
                active_link === '/employeur'
                  ? 'font-bold border-b-2 border-yellow'
                  : 'font-semibold'
              "
              class="text-sm text-black hover:text-gray-500"
              href="/employeur"
              >Employeurs</a
            >
          </li>
          <li (click)="toggleClassMenu('/ufa'); toggleMenu()">
            <a
              [ngClass]="
                active_link === '/ufa'
                  ? 'font-bold border-b-2 border-yellow'
                  : 'font-semibold'
              "
              class="text-sm text-black hover:text-gray-500"
              href="/ufa"
              >UFA</a
            >
          </li>
          <li (click)="toggleClassMenu('/partenaires'); toggleMenu()">
            <a
              [ngClass]="
                active_link === '/partenaires'
                  ? 'font-bold border-b-2 border-yellow'
                  : 'font-semibold'
              "
              class="text-sm text-black hover:text-gray-500"
              href="/partenaires"
              >Partenaires</a
            >
          </li>
          <li (click)="toggleClassMenu('/actualites'); toggleMenu()">
            <a
              [ngClass]="
                active_link === '/actualites'
                  ? 'font-bold border-b-2 border-yellow'
                  : 'font-semibold'
              "
              class="text-sm text-black hover:text-gray-500"
              href="/actualites"
              >Actualités</a
            >
          </li>
          <li (click)="toggleClassMenu('/contact'); toggleMenu()">
            <a
              [ngClass]="
                active_link === '/contact'
                  ? 'font-bold border-b-2 border-yellow'
                  : 'font-semibold'
              "
              class="text-sm text-black hover:text-gray-500"
              href="/contact"
              >Contact</a
            >
          </li>
        </ul>
      </div>
      <div class="mt-auto">
        <div class="pt-6">
          <div class="flex items-center justify-start gap-2">
            <a
              (click)="toggleMenu()"
              [href]="settings.facebook_url || 'https://m.facebook.com/CFA-Sant%C3%A9-Martinique-110004447996015/'"
              target="_blank"
              class="p-4 border rounded-xl border-yellow"
            >
              <img
                src="assets/svg/footer-facebook.svg"
                class="w-4 mx-auto hover:animate-pulse"
              />
            </a>
            <a
              (click)="toggleMenu()"
              [href]="settings.instagram_url || 'https://www.instagram.com/cfasante_mq/'"
              target="_blank"
              class="p-4 border rounded-xl border-yellow"
            >
              <img
                src="assets/svg/footer-instagram.svg"
                class="w-4 mx-auto hover:animate-pulse"
              />
            </a>
            <a
              (click)="toggleMenu()"
              [href]="settings.linkedin_url || 'https://www.linkedin.com/company/cfa-sant%C3%A9-martinique'"
              target="_blank"
              class="p-4 border rounded-xl border-yellow"
            >
              <img
                src="assets/svg/footer-linkedin.svg"
                class="w-4 mx-auto hover:animate-pulse"
              />
            </a>
          </div>
        </div>
      </div>
    </nav>
  </div>
</div>
